enum BrandEnum {
  Unknown = -1,
  FKAS = 1,
  TKAS = 2
}

export default BrandEnum